import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';
import palette from './palette.js';

const CustomSummaryTextField = styled(TextField)({
  [`& .${outlinedInputClasses.root}`]: {
    backgroundColor: palette.white,
    borderRadius: '25px',
    borderColor: palette.gt_grey_1,
  },
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: palette.gt_grey_1,
    borderRadius: '25px',
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: palette.gt_grey_1,
    },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: palette.gt_grey_1,
    },
});

export default CustomSummaryTextField;
